import { render, staticRenderFns } from "./FigmaPicker.vue?vue&type=template&id=b8687464&"
import script from "./FigmaPicker.vue?vue&type=script&lang=js&"
export * from "./FigmaPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports